import type { TFunction } from 'i18next';
import type { HmsSubject } from '../../api/hms';
import { Routes } from '../../enums/Routes';
import { buildRoute } from '../../utils/routeBuilder';

export type Decision = 'approve' | 'return';

/** What the safety representative just answered, shown until they leave the page */
export type LastDone =
  | { kind: 'documentation'; surveyId: number; decision: Decision; comment: string }
  | { kind: 'version'; subject: HmsSubject; decision: Decision; comment: string };

export const doneText = (done: LastDone, t: TFunction) => {
  if (done.decision === 'return')
    return t(
      done.kind === 'documentation' ? 'safetyRep.work.documentation.returnedText' : 'safetyRep.signing.returnedText',
      { comment: done.comment },
    );
  return done.kind === 'documentation'
    ? t('safetyRep.work.documentation.signedToday')
    : t(`safetyRep.signing.approvedText.${done.subject}`);
};

export const itemKey = (item: { subject: HmsSubject; id: number }) => `${item.subject}-${item.id}`;

export const versionRoute = (subject: HmsSubject, id: number) =>
  buildRoute(subject === 'riskMatrix' ? Routes.SafetyRepRiskMatrixVersion : Routes.SafetyRepTemplateVersion, {
    versionId: id,
  });

/** Another main safety representative or HR handled the version first */
export const alreadyHandled = (error: unknown) =>
  (error as { response?: { status?: number } } | null)?.response?.status === 409;

/** The version was made by the user themselves as HR, and no one approves their own work in another role */
export const isOwnVersionError = (error: unknown) =>
  (error as { response?: { data?: { code?: string } } } | null)?.response?.data?.code === 'ownVersion';

export const decisionError = (decision: Decision, confirmed: boolean, comment: string) =>
  decision === 'approve' ? !confirmed : !comment.trim();
